import { useMemo } from 'react';
import { EditWithAIWithModal } from '../EditWithAI';
import {
  RuleCardDropdown,
  type RuleCardDropdownProps,
  RulesContent,
  useRuleList,
} from '../RulesManager';
import { AIRulePreview } from './AIRulePreview';
import { useAIManagerContext } from './AiManagerContextProvider';
import type { AIManagerProps, Rule } from './types';
export interface AIRuleListItemProps extends Pick<AIManagerProps, 'pageUrl'> {
  rule: Rule;
  onDelete: (rule: Rule) => void;
}

export const AIRuleListItem = ({
  rule,
  pageUrl,
  onDelete,
}: AIRuleListItemProps) => {
  const { onCloseRule } = useRuleList();
  const { setEditRule, getAllSubGroupModifications } = useAIManagerContext();
  const dropdownItems = useMemo(
    () =>
      [
        {
          type: 'delete',
          onClick: () => onDelete(rule),
        },
      ] as RuleCardDropdownProps['items'],
    [rule]
  );

  return (
    <RulesContent.List.Item
      expandable
      id={rule.id}
      header={
        <AIRulePreview
          tooltipMessage="This rule applies on this page"
          isHighlighted={rule.content.pages.includes(pageUrl)}
          rule={rule}
          isDisabled={!rule.isActive}
          getAllSubGroupModifications={getAllSubGroupModifications}
        />
      }
      content={
        <EditWithAIWithModal
          removeExamples={true}
          pageUrl={pageUrl}
          onResponse={() => {
            setEditRule(rule);
            return Promise.resolve();
          }}
          rule={rule}
          initialPrompt={rule.content.prompt}
          onClose={() => onCloseRule(rule.id)}
          inputLabel="AI generated request"
        />
      }
      action={<RuleCardDropdown items={dropdownItems} />}
    />
  );
};
